import { fuelType } from './../../../../../../core/constants/FuelType';
import { chassisType } from './../../../../../../core/constants/ChassisType';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AddressLatLng } from 'src/app/shared/address-input/address-input.component';
import { scrollToElement } from 'src/app/shared/utilities/utils';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EditServiceService } from '../../edit-service.service';
import { VehicleInformation } from 'src/app/pages/active-routes/components/active-routes-detail/interfaces/ActiveRoutesDetail.interface';

@Component({
  selector: 'app-vehicle-route-info-step',
  templateUrl: './vehicle-route-info-step.component.html',
  styleUrls: ['./vehicle-route-info-step.component.scss']
})
export class VehicleRouteInfoStepComponent {
  ChassisType = chassisType;
  FuelType = fuelType;

  ContainerId: string = 'vehicle-route-info-step-container';
  OriginAddressId: string = 'originAddressId';
  DestinationAddressId: string = 'destinationAddressId';
  ProducErrorId: string = 'producErrorId';

  ShowProductErrorMessage: boolean = false;

  @Input()
  VehicleInformation: VehicleInformation | undefined;

  @Input() AddressForm: FormGroup | null | undefined;

  @Input() LoadingRoutes: boolean = false;

  constructor(private EditServiceService: EditServiceService) { }

  onOriginAddressDataEmitter(addressData: AddressLatLng) {
    this.showProductError(false);
    this.AddressForm?.get('OriginAddress')?.patchValue({
      Address: addressData.Address,
      Lat: addressData.Lat,
      Lng: addressData.Lng
    });
  }

  onDestinationAddressDataEmitter(addressData: AddressLatLng) {
    this.showProductError(false);
    this.AddressForm?.get('DestinationAddress')?.patchValue({
      Address: addressData.Address,
      Lat: addressData.Lat,
      Lng: addressData.Lng
    });
  }

  scrollToChild(childId: string): void {
    scrollToElement(this.ContainerId, childId);
  }

  showProductError(status: boolean) {
    this.ShowProductErrorMessage = status;
    if (status) {
      this.scrollToChild(this.ProducErrorId);
    }

  }


}
